import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React, { useState } from 'react';

import ContactCardGroup from '../../components/basic/ContactCardGroup';
import Filter from "../../components/basic/Filter";

export const ContactPatternPrime = ({ prime }) => {
  const [search, setSearch] = useState('');

  return (
    <>
      {prime.map((parent, n) => {
        return (
          <VStack key={`${parent.title}--${n}`} space='xs'>
            <VStack>
              <Text className="ml-2 text-2xl font-[700]text-secondary-900">{parent.title}</Text>
              {n == 0 ? (
                <VStack className="mt-4">
                  <Filter search={search} setSearch={setSearch} />
                </VStack>
              ) : undefined}
            </VStack>
            {parent.nested ? parent.nested.map((nested, m) => {
              return (
                <ContactCardGroup
                  key={`${nested.subtitle}--${n}-${m}`}
                  subtitle={nested.subtitle}
                  search={search}
                  entries={nested.entries}
                  entriesMaxRows={nested.entries_max_rows}
                  entryHeader={nested.entry_header}
                />
              );
            }) : undefined}
          </VStack>
        );
      })}
    </>
  );
}